export type StatusNames = {
  name:
    | 'Ferðabeiðni til samþykktar'
    | 'Kostnaður til samþykktar'
    | 'Samþykkt'
    | 'Kostnaður til yfirferðar'
    | 'Til staðfestingar'
    | 'Til samþykktar'
    | 'Lokið'
    | 'Hafnað';
};

export const EMAIL_STATUS_MAPPER = {
  TRAVEL_AUTHORIZE: {
    color: 'yellow',
    label: 'Ferðabeiðni til samþykktar',
    value: 'TRAVEL_AUTHORIZE',
  },
  TRAVEL_AUTHORIZE_CHANGE: {
    color: 'pink',
    label: 'Breytingar til samþykktar',
    value: 'TRAVEL_AUTHORIZE_CHANGE',
  },
  TRAVEL_APPROVE: {
    color: 'green',
    label: 'Kostnaður til samþykktar',
    value: 'TRAVEL_APPROVE',
  },
  TRAVEL_SUMMARY: {
    color: 'gray',
    label: 'Samantekt ferðabeiðnar til ferðaskrifstofu',
    value: 'TRAVEL_SUMMARY',
  },
  TRAVEL_CONFIRM: {
    color: 'teal',
    label: 'Kostnaður til staðfestingar',
    value: 'TRAVEL_CONFIRM',
  },
  TRAVEL_DETAILS: {
    color: 'yellow',
    label: 'Ferð hefur verið samþykkt',
    value: 'TRAVEL_DETAILS',
  },
  TRAVEL_REVIEW: {
    color: 'orange',
    label: 'Endurskoðun kostnaðar',
    value: 'TRAVEL_REVIEW',
  },
  TRAVEL_UPCOMING: {
    color: 'green',
    label: 'Ferð framundan',
    value: 'TRAVEL_UPCOMING',
  },
  TRAVEL_OVER: {
    color: 'green',
    label: 'Lokið',
    value: 'TRAVEL_OVER',
  },
  TRAVEL_REJECTED: {
    color: 'red',
    label: 'Hafnað',
    value: 'TRAVEL_REJECTED',
  },
};

export const EMAIL_OPTIONS = [
  {
    label: 'Ferðabeiðni til samþykktar',
    value: 'TRAVEL_AUTHORIZE',
  },
  {
    label: 'Breytingar á ferðabeiðni',
    value: 'TRAVEL_AUTHORIZE_CHANGE',
  },
  {
    label: 'Kostnaður til samþykktar',
    value: 'TRAVEL_APPROVE',
  },
  {
    label: 'Samantekt ferðabeiðnar til ferðaskrifstofu',
    value: 'TRAVEL_SUMMARY',
  },
  {
    label: 'Kostnaður til staðfestingar',
    value: 'TRAVEL_CONFIRM',
  },

  {
    label: 'Ferð framundan',
    value: 'TRAVEL_UPCOMING',
  },
  {
    label: 'Ferð lokið',
    value: 'TRAVEL_OVER',
  },
  {
    label: 'Kostnaður til endurskoðunar',
    value: 'TRAVEL_REVIEW',
  },
  {
    label: 'Ferð hefur verið samþykkt',
    value: 'TRAVEL_DETAILS',
  },
  {
    label: 'Ferðabeiðni hafnað',
    value: 'TRAVEL_REJECTED',
  },
];
